<template>
    <div class="header flex-row">
        <buttonc type="rectangle" :label="$t('global.ui.selectAll')" v-on:click="selectAllEmployees"
                 style="width: auto; height: auto; padding: 5px" />
        <buttonc type="rectangle" :label="$t('global.ui.deselectAll')" v-on:click="deselectAllEmployees"
                 style="width: auto; height: auto; padding: 5px" />
        <buttonc type="rectangle" :label="showOnlyActiveEmployees ? this.$t('report.main.showAllEmployees') : this.$t('report.main.showActiveEmployees')"
                 v-on:click="toggleShowOnlyActiveEmployees" style="width: auto; height: auto; padding: 5px; margin-left: auto" />
    </div>
</template>

<script>
    export default {
        name: 'EmployeeButtons',
        props: {
            selectAllEmployees: {
                type: Function,
                required: true,
            },
            deselectAllEmployees: {
                type: Function,
                required: true,
            },
            toggleShowOnlyActiveEmployees: {
                type: Function,
                required: true,
            },
            showOnlyActiveEmployees: Boolean,
        }
    }
</script>

<style scoped>
.flex-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}
</style>
